import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-set-keywords',
  templateUrl: './set-keywords.component.html',
  styleUrls: ['./set-keywords.component.scss'],
})
export class SetKeywordsComponent implements OnInit {

  @Output() keywordsChangedEvent: EventEmitter<string> = new EventEmitter<string>();

  @Input() keywords;

  constructor() { }

  ngOnInit() {
  }

  cancelClicked() {
    this.keywordsChangedEvent.emit('');
  }

  setClicked() {
    this.keywordsChangedEvent.emit(this.keywords);
  }

  keywordsChanged(event) {
    this.keywords = event.detail.value;
  }


}
